module.exports = __webpack_public_path__ + "static/media/activate-account-success.2437642b.svg";